import { Meta } from "../../../meta/meta";
import { useTranslation } from "react-i18next";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { getDownload } from "../../../utils/helpers";
import { Loader } from "../../../components/ui/loader";
import { GoBack } from "../../../components/ui/goBack";
import {
  getYouTubeEmbedUrl,
  removeFileExtensions,
} from "../../../utils/formatters";
import { NestedPages } from "../../../components/ui/nestedPages";
import { isNotEmptyArray } from "../../../utils/checkers";
import { useTanstackById } from "../../../hooks/useTanstack";
import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";

const ModelThree = ({
  id,
  title_am,
  title_en,
  description_am,
  description_en,
  image,
}) => {
  const mobile = useMediaQuery(`( max-width: 768px )`);

  const { t } = useTranslation();
  const { language } = useParams();
  const { data } = useTanstackById("getWebSingleItem", id);

  const title = language === "am" ? title_am : title_en;
  const description = language === "am" ? description_am : description_en;

  return (
    <>
      <Meta title={title} description={description} image={image} />
      {!data ? (
        <Loader />
      ) : (
        <main className={styles.modelThree}>
          <div className="container">
            <div className={styles.modelThree_context}>
              <GoBack />

              <div className={styles.modelThree_main}>
                <div className={styles.modelThree_main_column}>
                  {/* {isNotEmptyArray(data?.images) ? (
                    <div className={styles.modelThree_main_column_img}>
                      <img src={data?.images[0]} alt="mainImg" loading="lazy" />
                    </div>
                  ) : null} */}

                  <h1>{data?.name}</h1>

                  <div className={styles.modelThree_updateBlockSecond}>
                    <NestedPages />

                    <div className={styles.modelThree_updateSecond}>
                      <p>{t("update")}</p>
                      <span>{data?.updated}</span>
                    </div>
                  </div>

                  <div
                    className={styles.modelThree_main_column_text}
                    dangerouslySetInnerHTML={{
                      __html: data?.text,
                    }}
                  ></div>

                  {isNotEmptyArray(data?.files) ? (
                    <ul className={styles.model_files}>
                      {data?.files?.map(({ name, stored_name }) => {
                        return (
                          <li key={name} onClick={() => getDownload(name)}>
                            {removeFileExtensions(stored_name)}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}

                  {isNotEmptyArray(data?.links) ? (
                    <ul className={styles.model_links}>
                      {data?.links?.map((el) => {
                        const isYouTubeLink =
                          el?.includes("youtube.com") ||
                          el?.includes("youtu.be");
                        const embedUrl = getYouTubeEmbedUrl(el);

                        return (
                          <li key={el}>
                            {isYouTubeLink ? (
                              <iframe
                                width={mobile ? "100%" : "560"}
                                height="315"
                                src={embedUrl}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="YouTube video"
                              ></iframe>
                            ) : (
                              <a href={el} target="/blank" rel="noreferrer">
                                {el}
                              </a>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                </div>

                <div className={styles.modelThree_updateBlockFirst}>
                  <NestedPages />

                  <div className={styles.modelThree_updateFirst}>
                    <p>{t("update")}</p>
                    <span>{data?.updated}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      )}
    </>
  );
};

export default ModelThree;
